export default "__VITE_PUBLIC_ASSET__be0fa5eb__"